
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiPilotOnboard as ObiPilotOnboardElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-pilot-onboard.js';
 
 
 

 
 export const ObiPilotOnboard = createComponent({
   react: React,
   tagName: 'obi-pilot-onboard',
   elementClass: ObiPilotOnboardElement,
   events: {
     
   }
  });
 
 